import { authFetch } from "./authApi";

export function fetchOfftrackOverview() {
    return authFetch("/api/offtrack/admin/overview", {
        method: "GET",
    });
}

export function fetchOfftrackIncidents(hours = 48) {
    const safeHours = Math.max(1, Math.min(720, Number(hours) || 48));
    return authFetch(`/api/offtrack/admin/incidents?hours=${safeHours}`, {
        method: "GET",
    });
}

export function fetchOfftrackHistoryEvents() {
    return authFetch("/api/offtrack/admin/history/events", {
        method: "GET",
    });
}

export function fetchOfftrackHistoryEvent(eventGroupKey) {
    const key = String(eventGroupKey || "").trim();
    if (!key) {
        throw new Error("Kein Rennen für die Historie ausgewählt.");
    }
    return authFetch(`/api/offtrack/admin/history?event_group_key=${encodeURIComponent(key)}`, {
        method: "GET",
    });
}

export function revokeOfftrackClient(clientId) {
    return authFetch(`/api/offtrack/admin/clients/${Number(clientId)}/revoke`, {
        method: "POST",
    });
}

export function publishOfftrackRelease({ version, downloadUrl, releaseNotes = "", isMandatory = false }) {
    return authFetch("/api/offtrack/admin/releases", {
        method: "POST",
        body: JSON.stringify({
            version,
            download_url: downloadUrl,
            release_notes: releaseNotes,
            is_mandatory: Boolean(isMandatory),
        }),
    });
}

export function fetchLatestOfftrackRelease() {
    return authFetch("/api/offtrack/version?current_version=0.0.0", {
        method: "GET",
    });
}

export function fetchOfftrackDiagnostics({ hours = 24, driverId = "", sessionType = "", eventGroupKey = "", limit = 500 } = {}) {
    const params = new URLSearchParams();
    params.set("hours", String(Math.max(1, Math.min(720, Number(hours) || 24))));
    params.set("limit", String(Math.max(1, Math.min(1000, Number(limit) || 500))));
    if (driverId) params.set("driver_id", String(driverId));
    if (sessionType) params.set("session_type", String(sessionType));
    if (eventGroupKey) params.set("event_group_key", String(eventGroupKey));
    return authFetch(`/api/offtrack/admin/diagnostics?${params.toString()}`, {
        method: "GET",
    });
}
